// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__16P72","logo":"MainNavigation_logo__1gQYd","nav":"MainNavigation_nav__203gA","active":"MainNavigation_active__15J2A"};